<template>
  <span class="secondary--text">
    <div v-if="!nameShort">
      {{ showCups }}
    </div>
    <span v-else-if="value && value.length > 0" class="cups-row">
      <div v-for="(cup, i) in value" :key="cup.id" style="margin: 0 2px;">
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">{{ cup.nameShort }}</span>
          </template>
          <span>
            {{ cup.name }}
          </span>
        </v-tooltip>
        {{ value.length - 1 != i ? "|" : "" }}
      </div>
    </span>
  </span>
</template>
<script>
import gql from "fraql";

export default {
  name: "AppShowEventCups",
  props: {
    value: {
      type: Array,
      default: () => []
    },
    nameShort: {
      type: Boolean,
      default: false
    }
  },
  fragments: {
    cups: gql`
      fragment _ on Event {
        cups {
          id
          name
          nameShort
        }
      }
    `
  },
  computed: {
    showCups() {
      if (!this.value) return "";
      const nameType = this.nameShort ? "nameShort" : "name";
      let cups = this.value.map(x => x[nameType]);
      return cups.join(" | ");
    }
  }
};
</script>
<style scoped>
.cups-row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -2px;
}
</style>
